import { inject, Pipe, PipeTransform } from '@angular/core';
import { UiDataService } from '@common/components/my-account/tabs/backup-destination-tab/help-services/ui-data.service';
import { StorageType } from '@common/models';

@Pipe({
  name: 'isAvailableRegion',
  pure: true
})
export class IsAvailableRegionPipe implements PipeTransform {
  private readonly uiDataService = inject(UiDataService);

  transform(type: StorageType): boolean {
    return this.uiDataService.isAvailableRegion(type);
  }
}
